import React from "react";

/**
 * Chargement unifié pour les grilles de cartes
 * Affiche des cartes squelettes avec animation
 * @param {string} variant - "dark" (défaut) ou "light" pour le thème
 */
export function CardGridLoading({
  message,
  gridCols = "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  count = 8,
  cardClassName = "",
  variant = "dark",
}) {
  const isLight = variant === "light";
  const cardBase = isLight
    ? "bg-gray-100 border-gray-200"
    : "bg-white/10 dark:bg-slate-800/50 border-white/20 dark:border-slate-700/50";
  const skeletonBase = isLight
    ? "bg-gray-200"
    : "bg-white/20 dark:bg-slate-700/50";
  const textColor = isLight ? "text-gray-600" : "text-white/80";

  return (
    <div className="space-y-6">
      <div className={`grid ${gridCols} gap-4`}>
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className={`rounded-xl overflow-hidden border animate-pulse ${cardBase} ${cardClassName}`}
          >
            <div className={`h-40 ${skeletonBase}`} />
            <div className="p-3 space-y-2">
              <div className={`h-4 ${skeletonBase} rounded w-3/4`} />
              <div className={`h-3 ${skeletonBase} rounded w-1/3`} />
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center">
        <div className={`inline-flex items-center gap-2 text-sm ${textColor}`}>
          <div className="w-5 h-5 rounded-full border-2 border-orange-500/30 border-t-orange-500 animate-spin" />
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
}

export default CardGridLoading;
